import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { FileText } from "lucide-react";
import NurseDischargeModal from "./NurseDischargeModal";
import ClinicalSummary from "./ClinicalSummary";
import Diagnosis from "./Diagnosis";
import ClinicalDetails from "./ClinicalDetails";
import TreatmentSummary from "./TreatmentSummary";
import InvestigationSummary from "./InvestigationSummary";
import ConditionAtDischarge from "./ConditionAtDischarge";
import MedicationOnDischarge from "./MedicationOnDischarge";
import FollowUp from "./FollowUp";
import PatientInstructions from "./PatientInstructions";
import DietAdvice from "./DietAdvice";
import CarePlan from "./CarePlan";
import Disposition from "./Disposition";
import DoctorRemarks from "./DoctorRemarks";
import DoctorAuthentication from "./DoctorAuthentication";
import { setDischargeField } from "../../../../Redux/actions/dischargeActions";

export default function Discharge({
  patientDetails,
  patientId,
  admissionId,
  admission,
  onSaveSuccess,
}) {
  const dispatch = useDispatch();
  const [isNurseModalOpen, setIsNurseModalOpen] = useState(false);

  // Sync patientId and encounterId to redux state on mount / change
  useEffect(() => {
    if (patientId) {
      dispatch(setDischargeField("patientId", patientId));
    }
    if (admissionId || admission?.admissionId) {
      dispatch(
        setDischargeField(
          "encounterId",
          admission?.admissionNumber || admissionId || "ENC001"
        )
      );
    }
  }, [patientId, admissionId, admission, dispatch]);

  return (
    <div className="bg-gray-50/50 rounded-xl text-[#374151] p-4 sm:p-6 space-y-6 relative">
      <div className="flex justify-end mb-2">
        <button
          onClick={() => setIsNurseModalOpen(true)}
          className="flex items-center gap-2 bg-[#008b8b] hover:bg-[#007a7a] text-white px-4 py-2 rounded-lg font-medium transition-colors shadow-sm text-sm"
        >
          <FileText className="w-4 h-4" />
          Nurse Discharge Notes
        </button>
      </div>

      <NurseDischargeModal
        isOpen={isNurseModalOpen}
        onClose={() => setIsNurseModalOpen(false)}
        admissionNo={admission?.admissionNo || admission?.admissionNumber || patientDetails?.admissionNo || admissionId}
        patientId={patientId}
      />

      <div className="flex flex-col gap-6">
        {/* 1. Clinical Summary */}
        <ClinicalSummary />

        {/* 2. Diagnosis */}
        <Diagnosis />

        {/* 3. Clinical Details */}
        <ClinicalDetails />

        {/* 4. Treatment Summary */}
        <TreatmentSummary />

        {/* 5. Investigation Summary (Read Only) */}
        <InvestigationSummary
          patientDetails={patientDetails}
          patientId={patientId}
          admission={admission}
        />

        {/* 6. Condition at Discharge */}
        <ConditionAtDischarge />

        {/* 7. Medication on Discharge */}
        <MedicationOnDischarge />

        {/* 8. Follow-up */}
        <FollowUp />

        {/* 9. Patient Instructions */}
        <PatientInstructions />

        {/* 10. Diet Advice */}
        <DietAdvice />

        {/* 11. Care Plan */}
        <CarePlan />

        {/* 12. Disposition */}
        <Disposition />

        {/* 13. Doctor Remarks */}
        <DoctorRemarks />
      </div>

      {/* 14. Doctor Authentication / Footer */}
      <div className="pt-2">
        <DoctorAuthentication
          onSaveSuccess={onSaveSuccess}
          patientDetails={patientDetails}
          patientId={patientId}
          admission={admission}
          admissionId={admissionId}
        />
      </div>
    </div>
  );
}
